






















































































































import { NotificationHttp } from "@/mixins/http/notification";
// eslint-disable-next-line no-unused-vars
import { NotificationGroup } from "@/types/notification";
// eslint-disable-next-line no-unused-vars
import { AxiosResponse } from "axios";
import { Component, Mixins, Prop, Emit, Watch } from "vue-property-decorator";
import InfoBubble from "./InfoBubble.vue";
@Component({
	components: {
		"info-bubble": InfoBubble,
	},
})
export default class AddDomainDialog extends Mixins(NotificationHttp) {
	@Prop() show: boolean = false;
	@Prop() trackedHostnames!: string[];
	@Prop() groups!: NotificationGroup[];

	domainUrl: string = "";
	groupIdsDomainAddedTo: string[] = [];

	hostNameRules = [
		(inputText: string) =>
			/^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9-]*[A-Za-z0-9])$/.test(
				inputText
			) || "Host name not in a valid format",
		(inputText: string) =>
			!this.trackedHostnames.includes(inputText) || "Already tracking this domain",
	];

	formValid: boolean = false;

	get canTrackDomain(): boolean {
		return this.formValid && this.domainUrl != "";
	}

	@Emit("close-dialog")
	emitCloseDialog() {
		(this.$refs.form as any).reset();
		this.formValid = false;
	}

	addDomainToTrack() {
		this.$emit("track-domain", { hostname: this.domainUrl, groupIds: this.groupIdsDomainAddedTo });
		(this.$refs.form as any).reset();
		this.formValid = false;
	}

	@Watch("show")
	showValueChanged() {
		this.formValid = false;
	}
}
